import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { CustomerVehicleDetailsMultiple } from 'projects/Widget/src/app/business-entities/customer-vehicle-response.interface';
import { VehicleType } from './../../../../../../../Administration/src/app/business-entities/vehicleTypes-model';
import { Brand } from './../../../../business-entities/brand.interface';
import { CountryNameAndMobileCode } from './../../../../business-entities/country-name-and-mobile-code.interface';
import { Fuel } from './../../../../business-entities/fuel.interface';
import { FindCarService } from './../../../../business-services/find-car.service';

@Component({
  selector: 'confirm-reg-mobile-no',
  templateUrl: 'confirm-reg-mobile-no.component.html'
})
export class ConfirmRegMobileNoComponent implements OnInit {

  brandDropdown: Brand[] = [];
  countryDropdown: CountryNameAndMobileCode[] = [];
  fuelDropdown: Fuel[] = [];
  vehicleTypes: VehicleType[] = []
  vehicleCustomerDetailsMultiple: CustomerVehicleDetailsMultiple;
  CustomerVehicleForm: FormGroup;
  carColor: string;
  mobileNumber: string;
  @Input() mobileForm: boolean;
  @Input() registrationNumber: string;
  @Input() mobileNo: string;

  constructor(
    public activeModal: NgbActiveModal,
    private fcService: FindCarService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService,
    private toastr: ToastrService
  ) { }

  ngOnInit(): void {
     // This is intentional
  }
  onConfirm(): void {
    this.activeModal.close({ success: true });
  }

}

